module.exports = __webpack_public_path__ + "static/mo05-4f695c175978e60cc184828adfafce9c.png";